<template>
  <section
    v-if="freeShippings && freeShippings.length"
    class=" container"
    id="freeShipping"
  >
    <div class="baner_flash ">
      <router-link :to="'/FreeShipping'" class="products__slider__info__top1">
        <picture class="m-0">
          <source
            media="(max-width:768px)"
            srcset="../../../assets/images/baner_free_shipping_mb.jpg"
          />
          <img src="../../../assets/images/banerFlash.png" alt="" />
        </picture>
      </router-link>
    </div>
    <div class="products__slider__content  ">
      <div class="products__slider">
        <div class="title_products_flash">
          <router-link
            :to="'/FreeShipping'"
            class="products__slider__info__top1"
          >
            <div class="text-row word-rotate-box c-black border-white">
              <svg
                class="badge__emoji"
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <g clip-path="url(#clip0_161_568)">
                  <path
                    d="M10.7239 31.3072L19.0059 39.5891C19.2696 39.8523 19.627 40.0001 19.9995 40.0001C20.3721 40.0001 20.7295 39.8523 20.9932 39.5891L29.2752 31.3072C29.4582 31.1236 29.5608 30.8748 29.5606 30.6156C29.5604 30.3564 29.4573 30.1078 29.274 29.9245C29.0907 29.7412 28.8421 29.6381 28.5829 29.6379C28.3237 29.6377 28.075 29.7404 27.8913 29.9234L20.9781 36.8368V0.978516C20.9781 0.718997 20.875 0.470108 20.6915 0.286601C20.508 0.103093 20.2591 0 19.9995 0C19.74 0 19.4911 0.103093 19.3076 0.286601C19.1241 0.470108 19.021 0.718997 19.021 0.978516V36.8368L12.1077 29.9234C11.9241 29.7404 11.6754 29.6377 11.4162 29.6379C11.1569 29.6381 10.9084 29.7412 10.7251 29.9245C10.5418 30.1078 10.4387 30.3564 10.4385 30.6156C10.4383 30.8748 10.5409 31.1236 10.7239 31.3072Z"
                    fill="#000"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_161_568">
                    <rect width="40" height="40" fill="#000"></rect>
                  </clipPath>
                </defs>
              </svg>

              <span class="text__char" style="--char-rotate: 0deg">i</span
              ><span
                class="text__char"
                style="--char-rotate: 17.142857142857142deg"
                >l</span
              ><span
                class="text__char"
                style="--char-rotate: 34.285714285714285deg"
                >a</span
              ><span
                class="text__char"
                style="--char-rotate: 51.42857142857143deg"
                >n</span
              ><span
                class="text__char"
                style="--char-rotate: 68.57142857142857deg"
                >d</span
              >
              <span
                class="text__char"
                style="--char-rotate: 85.71428571428571deg"
                >-</span
              >
              <span
                class="text__char"
                style="--char-rotate: 102.85714285714286deg"
                >b</span
              ><span class="text__char" style="--char-rotate: 120deg">r</span>
              <span
                class="text__char"
                style="--char-rotate: 137.14285714285714deg"
              >
                a
              </span>
              <span
                class="text__char"
                style="--char-rotate: 154.28571428571428deg"
                >-</span
              >
              <span
                class="text__char"
                style="--char-rotate: 171.42857142857142deg"
              >
                i
              </span>
              <span
                class="text__char"
                style="--char-rotate: 188.57142857142856deg"
                >l</span
              ><span
                class="text__char"
                style="--char-rotate: 205.71428571428572deg"
                >a</span
              ><span
                class="text__char"
                style="--char-rotate: 222.85714285714286deg"
                >n</span
              >
              <span class="text__char" style="--char-rotate: 240deg">a</span>
              <span
                class="text__char"
                style="--char-rotate: 257.1428571428571deg"
                >d</span
              >
              <span
                class="text__char"
                style="--char-rotate: 274.2857142857143deg"
                >-</span
              >
              <span
                class="text__char"
                style="--char-rotate: 291.42857142857144deg"
                >b</span
              >

              <span
                class="text__char"
                style="--char-rotate: 308.57142857142856deg"
                >r</span
              >
              <span
                class="text__char"
                style="--char-rotate: 325.7142857142857deg"
                >a
              </span>
              <span class="text__char" style="--char-rotate: 345.714286deg"
                >-
              </span>
            </div>
          </router-link>
        </div>
        <div class="content_products_flash">
          <div class="" id="home_free_shipping">
            <div class=" swiper-container" v-if="freeShippings">
              <div
                class="swiper-wrapper "
                v-if="
                  freeShippings != '' &&
                    !disabledSliders.includes(
                      'myProducts-slider-home-freeShippings'
                    )
                "
              >
                <template>
                  <div
                    class="swiper-slide px-1 box-shaddow20"
                    v-for="(product, index) in freeShippings"
                    :key="index"
                  >
                    <Product :product="product"></Product>
                  </div>
                </template>
              </div>
            </div>
            <Loading v-else />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Swiper from "swiper/swiper-bundle.min";
import Product from "@/parts/Front/components/product/Product";
import Loading from "@/parts/Front/components/shared/Loading";

export default {
  name: "home_free_shipping",
  components: {
    Product,
    Loading,
  },
  data() {
    return {
      freeShippings: null,
    };
  },
  inject: ["mediaQueries"],

  created() {
    // if (this.$store.getters["front/getHomeData"] == null) {
    //   this.$store.dispatch("front/getHomeDataFromServer", {
    //     $root: this.$root,
    //   });
    // }
  },

  mounted() {
    this.initProductHomeSlider();
    this.requesrFreeShippings();
  },
  methods: {
    async requesrFreeShippings() {
      this.freeShippings = null;
      let res = await this.$store.dispatch(
        "front/getIndexPageContent",
        "free-shipping-products"
      );
      this.freeShippings = res;
    },
    initProductHomeSlider(kill = false) {
      this.initSwiper("home_free_shipping", kill, () => {
        new Swiper(`#home_free_shipping .swiper-container`, {
          spaceBetween: 30,
          loop: false,
          speed: 500,
          // autoplay: {
          //   delay: 5000,
          //   disableOnInteraction: false,
          // },

          breakpoints: {
            250: {
              slidesPerView: 2,
              spaceBetween: 1,
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1500: {
              slidesPerView: 5,
              spaceBetween: 20,
            },
          },
        });
      });
    },
  },
  computed: {
    // freeShippings() {
    //   if (this.$store.getters["front/getHomeData"] != null) {
    //     console.log(
    //       this.$store.getters["front/getHomeData"].free_shipping_products,
    //       "meysam"
    //     );
    //     return this.$store.getters["front/getHomeData"].free_shipping_products;
    //   } else {
    //     return null;
    //   }
    // },
  },
  watch: {
    freeShippings() {
      this.initProductHomeSlider();
    },
  },
};
</script>
<style scoped>
#freeShipping {
  margin-top: 60px;
}
.content_products_flash {
  width: 94%;
  margin-left: auto;
  margin-right: auto;
  padding: 94px 0 20px;
}
.text-row {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 130px;
  height: 130px;
  background: transparent;
  border-radius: 100%;
  animation: identifier 20s linear infinite;
  text-align: center;
}
.baner_flash {
}
.baner_flash img {
  width: 100%;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
}
.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}
.bg-light {
  background-color: #fff;
}
.text__char {
  display: block;
  position: absolute;
  top: 0;
  left: calc(50% - 70px);
  height: 70px;
  width: 140px;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 16px;
  transform-origin: bottom center;
  transform: rotate(var(--char-rotate));
  color: #000;
}
.text-row.border-white:after {
  border: 25px solid #fff;
}

.text-row:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 70%;
  height: 70%;
  z-index: -1;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}
.text-row {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 140px;
  height: 140px;
  background: transparent;
  border-radius: 100%;
  animation: identifier 20s linear infinite;
  text-align: center;
}
.badge__emoji {
  display: block;
  margin: 0;
  animation: identifier 20s linear infinite;
  animation-direction: reverse;
  transition: all 0.3s;
}
@keyframes identifier {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}

.title_products_flash {
  display: flex;
  justify-content: center;

  position: absolute;
  top: -7%;
  left: 50%;
  transform: translate(-50%, -7%);
}

.title_products_flash::after {
  content: "";
  position: absolute;
  top: 95%;
  left: 126%;
  width: 100%;
  height: 50%;
  background-size: contain;
  background-repeat: no-repeat;
  transform: scale(2.5) translate(-50%, -50%);
  z-index: -1;
  background-image: url(../../../assets/images/bgFlash.svg);
}

.text-row {
  width: 110px;
  height: 110px;
}
.text__char {
  height: 54px;
  width: 140px;
  font-size: 14px;
}
.text-row::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 60%;
  height: 60%;
  z-index: -1;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.badge__emoji {
  width: 30px;
  height: 30px;
}

@media screen and (max-width: 1200px) {
  .text-row {
    width: 90px;
    height: 90px;
    position: relative;
    top: 13%;
  }
  .text__char {
    height: 47px;
    width: 143px;
    font-size: 14px;
  }
  .text-row::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 54%;
    height: 54%;
    z-index: -1;
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }
  .title_products_flash::after {
    content: "";
    position: absolute;
    top: 160%;
    left: 126%;
    width: 100%;
    height: 80%;
    transform: scale(2.5) translate(-50%, -50%);
  }
  .badge__emoji {
    width: 20px;
    height: 20px;
  }
}

@media screen and (max-width: 580px) {
  .title_products_flash {
    top: -5%;
  }
  .text-row {
    position: relative;
    top: 7%;
  }
  .content_products_flash {
    padding: 95px 0 20px;
  }
}
.products__slider {
  background: #bdbcbc4d;
  background-size: 100% 65%;
  background-repeat: no-repeat;
  position: relative;
  top: 0px;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
}
.baner_flash img {
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}
.products__slider__info {
  position: relative;
  width: 350px;
  flex-shrink: 0;
  z-index: 1000;
}

.products__slider__info__top {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 57px;
  height: 85%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  padding-left: 15%;
  white-space: nowrap;
  z-index: 3;
}

.products__slider__info__top img {
  max-height: 100%;
}

.products__slider__info__bg {
  height: 106%;
  position: absolute;
  right: -43px;
  top: -18px;
  z-index: 2;
}
</style>
<style>
#freeShipping .swiper-button-next:after,
#freeShipping .swiper-rtl .swiper-button-prev:after {
  color: #000;
  font-size: 25px;
}
#freeShipping .swiper-button-next,
#freeShipping .swiper-rtl .swiper-button-prev {
  background-color: #fff;

  width: 45px;
  height: 45px;
  border-radius: 50%;
}
#freeShipping .swiper-button-prev,
#freeShipping .swiper-rtl .swiper-button-next {
  background-color: #fff;

  width: 45px;
  height: 45px;
  border-radius: 50%;
}
#freeShipping .swiper-button-prev:after,
#freeShipping .swiper-rtl .swiper-button-next:after {
  color: #000;
  font-size: 25px;
}
@media screen and (max-width: 600px) {
  #freeShipping .swiper-button-next,
  #freeShipping .swiper-rtl .swiper-button-prev {
    display: none;
  }
  #freeShipping .swiper-button-prev,
  #freeShipping .swiper-rtl .swiper-button-next {
    display: none;
  }
}
</style>
